<template>
  <div class="conrainer">
      <BigScreenHead>
          <template v-slot:left >
              <div class="head-left">
                  <div :style="{color:(type==1?'#EDB941':'')}" @click="checkTower">塔机</div>
                  <div :style="{color:(type==2?'#EDB941':'')}" @click="checkLifter">升降机</div>
              </div>
          </template>
          <template v-slot:center >
              <div class="head-title">设 备 生 产 管 理 板 块</div>
          </template>
      </BigScreenHead>
      <div class="info">
          <div class="year">
              <div class="year-top">
                  <p>本年度产量</p>
                  <p class="year-num1">{{chanliangInfo.yearYield}}</p>
              </div>
              <div class="year-bottom">
                  <div>
                      <p>今年月平均产量</p>
                      <p class="year-num2">{{chanliangInfo.yearAveMonthYield}}</p>
                  </div>
                  <div style="margin-left:20%">
                      <p>日平均</p>
                      <p class="year-num2">{{chanliangInfo.yearAveDayYield}}</p>
                  </div>
              </div>
          </div>
          <div class="year">
              <div class="year-top">
                  <p>本月度产量</p>
                  <p class="year-num1">{{chanliangInfo.monthYield}}</p>
              </div>
              <div class="year-bottom">
                  <div>
                      <p>本月周平均产量</p>
                      <p class="year-num2">{{chanliangInfo.monthAveWeekYield}}</p>
                  </div>
                  <div style="margin-left:20%">
                      <p>日平均</p>
                      <p class="year-num2">{{chanliangInfo.monthAveDayYield}}</p>
                  </div>
              </div>
          </div>
          <div class="linechart"></div>
          <div class="peichart"></div>
          <ul class="xinghao-ul">
              <li class="xinghao-li">
                  <p style="color:#EDB941">TOP1</p>
                  <p style="width:45%;">{{modelData[0] && modelData[0].model + ':'}}</p>
                  <p style="margin-right:5%;">{{modelData[0] && modelData[0].count+ ' 台'}}</p>
                  <p>{{modelData[0] && modelData[0].bili + '%'}}</p>
              </li>
              <li class="xinghao-li">
                  <p style="color:#40b337">TOP2</p>
                  <p style="width:45%;">{{modelData[1] && modelData[1].model + ':'}}</p>
                  <p style="margin-right:5%;">{{modelData[1] && modelData[1].count+ ' 台'}}</p>
                  <p>{{modelData[1] && modelData[1].bili + '%'}}</p>
              </li>
              <li class="xinghao-li">
                  <p style="color:#7194F3">TOP3</p>
                  <p style="width:45%;">{{modelData[2] && modelData[2].model + ':'}}</p>
                  <p style="margin-right:5%;">{{modelData[2] && modelData[2].count+ ' 台'}}</p>
                  <p>{{modelData[2] && modelData[2].bili + '%'}}</p>
              </li>
              <li class="xinghao-li">
                  <p>TOP4</p>
                  <p style="width:45%;">{{modelData[3] && modelData[3].model + ':'}}</p>
                  <p style="margin-right:5%;">{{modelData[3] && modelData[3].count+ ' 台'}}</p>
                  <p>{{modelData[3] && modelData[3].bili + '%'}}</p>
              </li>
              <li class="xinghao-li">
                  <p>TOP5</p>
                  <p style="width:45%;">{{modelData[4] && modelData[4].model + ':'}}</p>
                  <p style="margin-right:5%;">{{modelData[4] && modelData[4].count+ ' 台'}}</p>
                  <p>{{modelData[4] && modelData[4].bili + '%'}}</p>
              </li>
          </ul>
          <div class="bartitle">
              <p>年</p><p>度</p><p>发</p><p>货</p><p>排</p><p>行</p>
            </div>
          <div class="barchart"></div>
          <div class="fuyiBar"></div>
          <div class="hehe">
              <div style="color:#40b337">正常：{{fuyiData.normal}} 台</div>
              <div style="color:#EDB941">一年内到期：{{fuyiData.aYearOverdue}} 台</div>
              <div style="color:#bf0000">已超期：{{fuyiData.overdue}} 台</div>
          </div>
      </div>
      <div class="bottom">
          <div class="bottom-left">
              <div class="mapchart"></div>
              <div class="mapinfo">
                  <ul>
                      <li style="color:#ffffff"><i class="iconfont" style="color:#ffffff;margin-right:10px">{{type==1?'&#xe612;':'&#xe613;'}}</i>总数：{{mapInfo.total}}</li>
                      <li style="color:#EDB941"><i class="iconfont" style="color:#EDB941;margin-right:10px">{{type==1?'&#xe612;':'&#xe613;'}}</i>未通电：{{mapInfo.noPower}}</li>
                      <li style="color:#bf0000"><i class="iconfont" style="color:#bf0000;margin-right:10px">{{type==1?'&#xe612;':'&#xe613;'}}</i>超期：{{mapInfo.overdue}}</li>
                      <li style="color:#40b337"><i class="iconfont" style="color:#40b337;margin-right:10px">{{type==1?'&#xe612;':'&#xe613;'}}</i>在线：{{mapInfo.online}}</li>
                      <li style="color:#7194F3"><i class="iconfont" style="color:#7194F3;margin-right:10px">{{type==1?'&#xe612;':'&#xe613;'}}</i>信号差：{{mapInfo.signalBad}}</li>
                      <li style="color:#bf0000"><i class="iconfont" style="color:#bf0000;margin-right:10px">{{type==1?'&#xe612;':'&#xe613;'}}</i>锁机：{{mapInfo.lockMachine}}</li>
                  </ul>
              </div>
          </div>
          <div class="bottom-right">
              <div class="bottom-right-top">
                  <input  class="top-input" type="text" placeholder="产品编号 /IMEI /规格型号 /客户名称" v-model="inputValue">
                  <button class="top-btn" @click="search">查 询</button>
                  <button class="top-btn top-btn-2" @click="reset">重 置</button>
              </div>
              <div class="table-div">
                  <table>
                    <tr>
                        <td style="width:40px"></td>
                        <td>产品编号</td>
                        <td>IMEI</td>
                        <td>规格型号</td>
                        <td>客户名称</td>
                        <td>销售公司</td>
                        <td style="width:70px">联网状态</td>
                        <td>最后在线</td>
                        <td style="width:9%">本月还款状态</td>
                        <td style="width:70px">锁机状态</td>
                        <td :style="{width: type==2?'11%':'8%'}">设备实况</td>
                    </tr>
                    <tr v-for="(item,i) in list" :key="item.id">
                        <td>{{i+1}}</td>
                        <td v-overflow>{{item.machineNo}}</td>
                        <td v-overflow>{{item.id && (item.imei?item.imei:'') + ' ' + (item.rightImei?item.rightImei:'')}}</td>
                        <td v-overflow>{{item.modelName}}</td>
                        <td v-overflow>{{item.customerName}}</td>
                        <td v-overflow>{{item.salesCompanyName}}</td>
                        <td v-overflow :style="{color:item.onlineColor}">{{item.onlineText}}</td>
                        <td v-overflow>{{item.lastOnlineDate | timeFomart}}</td>
                        <td v-overflow :style="{color:item.loanColor}">{{item.loanText}}</td>
                        <td v-overflow :style="{color:item.lockColor}">{{item.lockText}}</td>
                        <td v-if="type==1">
                            <button v-if="item.id" style="width:60%" class="tab-btn" @click="toDevice(item,1)">查 看</button>
                        </td>
                        <td v-else>
                            <button :disabled="!item.imei" :style="{background:!item.imei && '#ccc'}" v-if="item.id" class="tab-btn" @click="toDevice(item,1)">左 笼</button>
                            <button :disabled="!item.rightImei" :style="{marginLeft:'7%',background: !item.rightImei && '#ccc'}" v-if="item.id" class="tab-btn" @click="toDevice(item,2)">右 笼</button>
                        </td>
                    </tr>
                </table>
              </div>
              <div class="page">
                  <div @click="prev">上一页</div>
                  <div style="margin:0 2%;">第{{option.pageIndex}}页 共{{total}}条</div>
                  <div @click="next">下一页</div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { shengchanLine,shengchanPie,shengchanBar,shengfuyiBar,shengchanMap } from '../assets/js/echarts'
var fromPath = '';
export default {

    data(){
        
        return{
            type: 1,
            inputValue:'',
            option:{
                type: 1,
                filter: '',
                pageSize: 15,
                pageIndex: 1,
            },
            chanliangInfo: {},
            modelData:[],
            goodsData:[],
            mapInfo:{},
            list:[],
            listLength:0,
            total:0,
            fuyiData:{}
        }
    },
    methods:{
        //格式化表格，没有15个数据时填满15个
        listFomart(option){
            if(option.length < 15){
                for(let i=option.length; i<15; i++){
                    option.push({})
                }
            }
        },
        //设备产量信息
        getDeviceYieldInfo(option){
            this.$api.DeviceYieldInfo(option).then(res=>{
                this.chanliangInfo = res.data.data;
                var tempData = []
                this.chanliangInfo.yieldDate.map(item=>{
                    tempData.push(item.slice(3,5))
                })
                shengchanLine({doc:'.linechart',date:tempData,data:this.chanliangInfo.yieldValue});
            })
        },
        //规格型号排行
        getModelRankingInfo(option){
            this.$api.ModelRankingInfo(option).then(res=>{
                this.modelData = res.data.data.data;
                this.modelTotal = res.data.data.total;
                var chartData = [];
                this.modelData.map((item,i)=>{
                    if(this.modelTotal==0 || item.count==0){
                        item.bili = 0
                    }else{
                        item.bili = (item.count/this.modelTotal*100).toFixed(0)
                    }
                    chartData.push({
                        name:item.model,
                        value:item.bili
                    });
                })
                if(this.modelData.length > 5){
                    this.modelData.length = 5
                }
                shengchanPie({doc:'.peichart',data:chartData});
            })
        },
        //年度发货排行榜
        getDeliverGoodsInfo(option){
            this.$api.DeliverGoodsInfo(option).then(res=>{
                this.goodsData = res.data.data;
                var chartData = [];
                var max = 0;
                this.goodsData.map(item=>{
                    chartData.push({
                        name: item.areaName,
                        value: item.number
                    });
                    if(item.number > max){
                        max = item.number
                    }
                })
                if(chartData.length>5){ chartData.length = 5 };
                shengchanBar({doc:'.barchart',data:chartData,max});
            })
        },
        //超期服役
        getDeliverWorkInfo(option){
            this.$api.DeliverWorkInfo(option).then(res=>{
                var chartData = res.data.data
                this.fuyiData = res.data.data
                shengfuyiBar({doc:'.fuyiBar',normal:chartData.normal,aYearOverdue:chartData.aYearOverdue,overdue:chartData.overdue});
            })
        },
        //地图数据
        getDeviceMapTotalInfo(option){
            this.$api.DeviceMapTotalInfo(option).then(res=>{
                this.mapInfo = res.data.data;
                var chartData = [];
                res.data.data.data.map(item=>{
                    chartData.push({
                        name: item.sendAddress,
                        value: [item.gpsX,item.gpsY],
                        imei: item.imei,
                        rightImei: item.rightImei,
                        factorNo: item.factorNo,
                        type: item.type,
                        onlineState: item.onlineState,
                        lockState: item.lockState,
                        loanState: item.loanState,
                    })
                });
                shengchanMap({doc:'.mapchart',data:chartData});
            })
        },
        //表格数据
        getDeviceDataListInfo(option){
            this.$api.DeviceDataListInfo(option).then(res=>{
                this.listLength = res.data.data.data.length;
                this.total = res.data.data.total;
                this.listFomart(res.data.data.data)
                res.data.data.data.map(item=>{
                    if (!item.id) return
                    if(item.onlineState == 0) {
                        item.onlineColor = '#edb941'
                        item.onlineText = '未通电'
                    }
                    if(item.onlineState == 1) {
                        item.onlineColor = '#40b337'
                        item.onlineText = '在线'
                    }
                    if(item.onlineState == 2) {
                        item.onlineColor = '#7194f3'
                        item.onlineText = '信号差'
                    }
                    if(item.loanState == 3) {
                        item.loanColor = '#40b337'
                        item.loanText = '已还款'
                    }else{
                        item.loanColor = '#bf0000'
                        if(item.loanState == 1){
                            item.loanText = '已超期'
                        }
                        if(item.loanState == 2){
                            item.loanText = '超期还款'
                        }
                        if(item.loanState == 0){
                            item.loanText = '未还款'
                        }
                    }
                    if(item.lockState == 0) {
                        item.lockColor = '#40b337'
                        item.lockText = '未锁机'
                    }else{
                        item.lockColor = '#40b337'
                        item.lockText = '已锁机'
                    }
                })
                this.list = res.data.data.data;
            })
        },
        //切换塔机
        checkTower(){
            localStorage.type = 1;
            localStorage.pageIndex = 1
            this.type = 1;
            this.option = {
                type: this.type,
                filter: '',
                pageSize: 15,
                pageIndex: 1,
            };
            this.getDeviceYieldInfo({type:this.type});
            this.getModelRankingInfo({type:this.type});
            this.getDeliverGoodsInfo({type:this.type});
            this.getDeviceMapTotalInfo({type:this.type});
            this.getDeviceDataListInfo(this.option);
            this.getDeliverWorkInfo({type:this.type})
        },
        //切换升降机
        checkLifter(){
            localStorage.type = 2;
            localStorage.pageIndex = 1;
            this.type = 2;
            this.option = {
                type: this.type,
                filter: '',
                pageSize: 15,
                pageIndex: 1,
            };
            this.getDeviceYieldInfo({type:this.type});
            this.getModelRankingInfo({type:this.type});
            this.getDeliverGoodsInfo({type:this.type});
            this.getDeviceMapTotalInfo({type:this.type});
            this.getDeviceDataListInfo(this.option);
            this.getDeliverWorkInfo({type:this.type})
        },
        //跳转设备页面
        toDevice(item,p){
            if(item.type==1){
                this.$router.push('/TowerBigScreen?imei='+item.imei)
            }else{
                if(p == 1){
                    this.$router.push('/LifterBigScreen?imei='+item.imei + '&cagecate=' + 1)
                }else{
                    this.$router.push('/LifterBigScreen?imei='+item.rightImei + '&cagecate=' + 2)
                }
            }
        },
        //搜索
        search(){
            this.option = {
                type: this.type,
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1,
            };
            this.getDeviceDataListInfo(this.option);
        },
        //重置
        reset(){
            this.inputValue = '';
            this.option = {
                type: this.type,
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1,
            };
            this.getDeviceDataListInfo(this.option);
        },
        //上一页
        prev(){
            if (this.option.pageIndex <= 1) return;
            this.option.pageIndex --;
            this.getDeviceDataListInfo(this.option);
            localStorage.pageIndex = this.option.pageIndex;
        },
        //下一页
        next(){
            if(this.listLength < 15) return;
            this.option.pageIndex ++;
            this.getDeviceDataListInfo(this.option);
            localStorage.pageIndex = this.option.pageIndex;
        }
    },
    beforeRouteEnter:(to,from,next)=>{
        fromPath = from.path
        next();
    },
    mounted(){
        const keepAlive = async () => {
            var type = localStorage.type;
            var pageIndex = localStorage.pageIndex;
            if(fromPath == '/BigScreen'){
                type = 1
                pageIndex = 1;
                localStorage.pageIndex = 1;
            }
            if(type){
                this.type = type;
                this.option.type = type;
            }
            if(pageIndex){
                this.option.pageIndex = pageIndex
            }
        };
        keepAlive().then(()=>{
            this.getDeviceYieldInfo({type:this.type});
            this.getModelRankingInfo({type:this.type});
            this.getDeliverGoodsInfo({type:this.type});
            this.getDeviceMapTotalInfo({type:this.type});
            this.getDeviceDataListInfo(this.option);
            this.getDeliverWorkInfo({type:this.type})
        })
    },
}
</script>

<style lang="scss" scoped>
.iconfont{
    font-family:"iconfont" !important;
    font-size: 27px;
    font-style: normal;
    color: #EDB941;
}
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}
.head-left{
    display: flex;
    justify-content: space-between;
    width: 23%;
    font-size: 1.15rem;
    font-weight: bold;
    margin-left: 2%;
    & div{
        cursor: pointer;
    }
}
.head-title{
    font-size: 1.5625rem;
    font-weight: bold;
    letter-spacing: 5px;
}
.info{
    width: 100%;
    height: 19%;
    display: flex;
    padding: 0 20px;
    margin: 0.625rem 0;
    margin-bottom: 0.725rem;
    position: relative;
}
.hehe{
    position: absolute;
    right: 0.8125rem;
    top: 0.625rem;
    background: rgba($color: #000000, $alpha: 0.5);
    width: 9rem;
    height: 4.75rem;
    font-size: 0.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 7px;
    div{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
.bottom{
    width: 100%;
    flex: 1;
    display: flex;
    padding: 0 20px;
}
.year{
    width: 11%;
    height: 97%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p{
        white-space: nowrap;
    }
}
.year-top{
    margin-top: 11%;
    font-weight: bold;
}
.year-num1{
    font-size: 1.875rem;
    margin-top: 1%;
    color: #EDB941;
}
.year-num2{
    margin-top: 5%;
    font-size: 1.3rem;
}
.year-bottom{
    display: flex;
    font-size: 0.9375rem;
}
.linechart{
    width: 22%;
}
.peichart{
    width: 11%;
}
.xinghao-ul{
    width: 16%;
    margin-top: 0.5%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.xinghao-li{
    display: flex;
    justify-content: space-between;
    align-content: space-between;
    font-weight: bold;
    font-size: 0.85rem;
    p{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.bartitle{
    width: 3%;
    box-sizing: border-box;
    color: #EDB941;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
}
.barchart{
    width: 18%;
}
.fuyiBar{
    width: 14%;
}
.bottom-left{
    width: 42%;
    display: flex;
    flex-direction: column;
}
.mapchart{
    height: 83%;
}
.mapinfo{
    flex: 1;
    ul{
        width: 100%;
        height: 85%;
        margin-top: 0.5%;
        display: flex;
        flex-wrap: wrap;
        li{
            height: 50%;
            width: 33.3%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.9375rem;
        }
    }
}
.bottom-right{
    //border: 1px solid red;
    flex: 1;
    padding-left: 0.625rem;
    display: flex;
    flex-direction: column;
    .table-div{
        flex: 1;
        //border: 1px solid red;
    }
    table{
        border-collapse: collapse;
        width: 100%;
        height: 100%;
        flex: 1;
        text-align: center;
        font-size: 0.875rem;
        table-layout: fixed;
        td{
            border: 1px solid #fff;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
    .tab-btn{
        color: #fff;
        background: #EDB941;
        border-radius: 5px;
        width: 40%;
        height: 56%;
        font-weight: bold;
        font-size: 0.75rem;
        cursor: pointer;
    }
    .page{
        //border: 1px solid red;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 7%;
        font-weight:bold;
        font-size: 0.9375rem;
        & div{ cursor: pointer;}
        & div:active{ color: #EDB941;}
    }
}
.bottom-right-top{
    height: 6%;
    display: flex;
    align-items: center;
    //border: 1px solid red;
    .top-input{
        padding-left: 10px;
        border: 1px solid #fff;
        color: #fff;
        border-radius: 2px;
        height: 70%;
        width: 30%;
        background: none;
        outline: none;
    }
    .top-btn{
        margin-left: 1.25rem;
        width: 3.75rem;
        height: 1.6rem;
        border-radius: 5px;
        color: #fff;
        background: #EDB941;
        cursor: pointer;
        padding: 0;
        line-height: 0;
        font-weight: bold;
        font-size: 0.75rem;
    }
    .top-btn:active{
        background: rgba($color: #EDB941, $alpha: 0.9);
    }
    .top-btn-2{
        background: #7194F3;
    }
    .top-btn-2:active{
        background: rgba($color: #7194F3, $alpha: 0.9);
    }
}
</style>